var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'UIElement',
    _vm.$style.AppFrame,
    _vm.$slots.nav && _vm.$style.AppFrame__hasNav
  ]},[_c('div',{class:_vm.$style.AppFrameNav},[_c('div',{class:_vm.$style.AppFrameNav_logoWrapper}),_c('div'),_c('div')]),_c('div',{class:_vm.$style.AppFrame_navWrapper},[_vm._t("nav")],2),_c('div',{class:_vm.$style.AppFrame_contentWrapper},[_c('div',{class:_vm.$style.AppFrame_content},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }